import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateAddressMutation as _UpdateAddressMutation,
  UpdateAddressInput,
} from '@/gql/graphql';
import { pick } from 'lodash-es';

const UpdateAddressMutation = graphql(`
  mutation UpdateAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      id
    }
  }
`);

const useUpdateAddress = (
  options?: UseMutationOptions<
    _UpdateAddressMutation,
    unknown,
    UpdateAddressInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      const address = pick(input, [
        'city',
        'contacts',
        'country',
        'id',
        'line1',
        'line2',
        'administrativeArea',
        'postalCode',
      ]);

      return gqlClient.request(UpdateAddressMutation, {
        input: {
          ...address,
          // Callers often pass through already-saved Contact objects, which
          // carry fields (publicId, __typename) that UpdateAddressContactInput
          // rejects. Strip each contact to the allowed input fields.
          contacts: address.contacts?.map((contact) =>
            pick(contact, ['id', 'name', 'description', 'email', 'phone'])
          ),
        },
      });
    },
    ...options,
  });
};

export default useUpdateAddress;
